var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0.333984H10C7.34784 0.333984 4.8043 1.38755 2.92893 3.26292C1.05357 5.13828 0 7.68182 0 10.334L0 22.334C0 24.9861 1.05357 27.5297 2.92893 29.4051C4.8043 31.2804 7.34784 32.334 10 32.334H22C24.6522 32.334 27.1957 31.2804 29.0711 29.4051C30.9464 27.5297 32 24.9861 32 22.334V10.334C32 7.68182 30.9464 5.13828 29.0711 3.26292C27.1957 1.38755 24.6522 0.333984 22 0.333984ZM29 22.334C29 26.194 25.86 29.334 22 29.334H10C6.14 29.334 3 26.194 3 22.334V10.334C3 6.47398 6.14 3.33398 10 3.33398H22C25.86 3.33398 29 6.47398 29 10.334V22.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.33398C13.8783 8.33398 11.8434 9.17684 10.3431 10.6771C8.84285 12.1774 8 14.2123 8 16.334C8 18.4557 8.84285 20.4905 10.3431 21.9908C11.8434 23.4911 13.8783 24.334 16 24.334C18.1217 24.334 20.1566 23.4911 21.6569 21.9908C23.1571 20.4905 24 18.4557 24 16.334C24 14.2123 23.1571 12.1774 21.6569 10.6771C20.1566 9.17684 18.1217 8.33398 16 8.33398ZM16 21.334C14.6744 21.3324 13.4036 20.8051 12.4662 19.8678C11.5289 18.9304 11.0016 17.6596 11 16.334C11 13.576 13.244 11.334 16 11.334C18.756 11.334 21 13.576 21 16.334C21 19.09 18.756 21.334 16 21.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6002 8.79997C25.1889 8.79997 25.6662 8.3227 25.6662 7.73397C25.6662 7.14523 25.1889 6.66797 24.6002 6.66797C24.0114 6.66797 23.5342 7.14523 23.5342 7.73397C23.5342 8.3227 24.0114 8.79997 24.6002 8.79997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagram_white.351cb6ae3bc68ff7da3fa0fd340ba1f5.svg";
export { ForwardRef as ReactComponent };